
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqCQZtfbKpK9_aXsu1TvSVsGmlMnYx4_BSxgUh5e6TvScMeta } from "/codebuild/output/src2681438712/src/src/pages/faq.vue?macro=true";
import { default as menuFW_45BKAPgy9ExHRoWrsfKaUwtOo_3L7M_45yDEHBmwx28EMeta } from "/codebuild/output/src2681438712/src/src/pages/menu.vue?macro=true";
import { default as indexVpUGoF8zpokfJjg3aUEq_PP8sAS0DdQ1iUBpzScPjhoMeta } from "/codebuild/output/src2681438712/src/src/pages/index.vue?macro=true";
import { default as contactciur2mvvC6XhA54M41KRjgv1uUKXyHwR98r8amiGLHIMeta } from "/codebuild/output/src2681438712/src/src/pages/contact.vue?macro=true";
import { default as tutorialc9euYnvNR3QhXY4aXB82ZFzmJNSi_Gfrz8DVQSPXIdQMeta } from "/codebuild/output/src2681438712/src/src/pages/tutorial.vue?macro=true";
import { default as agreementCR5uIVwijETikouDRlFbPho_453ywUTavBXenzMAhF__YMeta } from "/codebuild/output/src2681438712/src/src/pages/agreement.vue?macro=true";
import { default as about_45passM4uARZ1Pc9lKSrf60HWqKhwk5ZxYY5EKmRxJi9U36UQMeta } from "/codebuild/output/src2681438712/src/src/pages/about-pass.vue?macro=true";
import { default as indexwkKA39imr2QK0YhazRU04yxDB1HX8pnyA5CkhKeWHvkMeta } from "/codebuild/output/src2681438712/src/src/pages/card/index.vue?macro=true";
import { default as _91id_939gl9HCCEXyIPQ_45YL8rssLcURoLxug_45lw64pqr2Z8ovYMeta } from "/codebuild/output/src2681438712/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceSJmqLyn4vTPxwm4MuMSgwEuB7O_45br3pEMfTVqpzOrcUMeta } from "/codebuild/output/src2681438712/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93vHIrIYiScc9674UhYwM_45D_Aph7mi2FqKvrIqX9XQfAQMeta } from "/codebuild/output/src2681438712/src/src/pages/notice/[id].vue?macro=true";
import { default as indexJn4uWZaq5W3QNtKdNrOFNrqdAkr4xV844BM2lsPuYRkMeta } from "/codebuild/output/src2681438712/src/src/pages/coupon/index.vue?macro=true";
import { default as indexNVo8eSkbtM_457f5oLmc_i13M0vos1_Ez_zy1Y_45r4_4534wMeta } from "/codebuild/output/src2681438712/src/src/pages/mypage/index.vue?macro=true";
import { default as indexf04LcmZDXCD79l_36tOH17IPzoesqOoNHNWX80TtZ_450Meta } from "/codebuild/output/src2681438712/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93EeYjFK9LQEgCLGBKqz8SO34_pmW7a0mfe2Ya7DjHaM8Meta } from "/codebuild/output/src2681438712/src/src/pages/parking/[id].vue?macro=true";
import { default as indexm9K9UfKa4QbXDu49JcDkdLxf3ULxz0GGZAx11sMXYcYMeta } from "/codebuild/output/src2681438712/src/src/pages/history/index.vue?macro=true";
import { default as indexWTohM0_454HJnOL7OtG12tSCuEU7cWbt9CUIUfk3VgiLkMeta } from "/codebuild/output/src2681438712/src/src/pages/monthly/index.vue?macro=true";
import { default as indexxU9xeynoDn78ZCCkRpSHWR8cJSa4aWCwlf6POgqIvLEMeta } from "/codebuild/output/src2681438712/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexDA7DYLiS4CEK0AjNZl8FfI_45Y_456lnjcBV2OvJn4tYZIAMeta } from "/codebuild/output/src2681438712/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviAc7WrKQCHKR7I7VfF8ANqg9u19JgJ_451695s4_JEdmA8Meta } from "/codebuild/output/src2681438712/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editH5GXTFiy6IBut0iSFumBNKWc1Idu9MtmTV4qhqeMZhsMeta } from "/codebuild/output/src2681438712/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementNH4BAk1XzewRy4rZRS7Bj12YbLqFNQeEM0y57ILnCXsMeta } from "/codebuild/output/src2681438712/src/src/pages/pass-agreement.vue?macro=true";
import { default as index8I7puBKo1TLtDzXKHHSSjEwlJ0YVI_45b84XMVigF2hOkMeta } from "/codebuild/output/src2681438712/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dIeJXEX77xfZj5ZtxtvAQLdEhmf7HjZHU1J4RveQJ3NkMeta } from "/codebuild/output/src2681438712/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirm6U3JeCXDymilsWT7OoY0x8n1u_45sxgh6_450ejMNrKb_457QMeta } from "/codebuild/output/src2681438712/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexWLKdjoGcezofSuQjAltGyJzfxIrTlvSruOLGaCMIwwEMeta } from "/codebuild/output/src2681438712/src/src/pages/card/create/index.vue?macro=true";
import { default as indexcE7XSNxNbcfTqXvSf6CDqzEgNYLUX_kKGTrGyWFCTx8Meta } from "/codebuild/output/src2681438712/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmctxw9RKu1weOa_453Yvw6sZIldpCzsDQU5j4IQg_y_i8wMeta } from "/codebuild/output/src2681438712/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirm94g0usZr3JglO_45zhHlTO04w0dS_45nij8CDD4K_Rqzi_45IMeta } from "/codebuild/output/src2681438712/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completef72axcb1Mjir0CdUZTQTo8YH_45I0API2biiJ5cwJKji8Meta } from "/codebuild/output/src2681438712/src/src/pages/membership/complete.vue?macro=true";
import { default as registerTDUsPStpFePLBWwgaUKhGLCoozJE8vsAdHnvKoXIrbIMeta } from "/codebuild/output/src2681438712/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93N4phAF3Vw3kwCYlVYNUVN4NMCp0Eqi146LnYzJeCTS0Meta } from "/codebuild/output/src2681438712/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmqAx0TLigaYXzwLXzhYSgIuQf7OS8INrs6ScLYCVJJjsMeta } from "/codebuild/output/src2681438712/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93j_bkcipWMRQt_12SYPdp6LOTbIYuEjt6LOQ4Ak_45JrkYMeta } from "/codebuild/output/src2681438712/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexUGzhZMQNAdvkHnZuwc2gY7RSLk54bU7E0zpXt4fP5i0Meta } from "/codebuild/output/src2681438712/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeDpX5ERMCjxG3KQK1k7MZJjsOKxUoon_45QzzqcTvPS720Meta } from "/codebuild/output/src2681438712/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codepc7LlaUEewiDv0azfhu4vFgkUcCxRdBs86S_03zqJu0Meta } from "/codebuild/output/src2681438712/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeekkJr_SsLOMG4_45Bro1fRWccA8LPSqDDAZKnyCVCQYAoMeta } from "/codebuild/output/src2681438712/src/src/pages/contact-form/complete.vue?macro=true";
import { default as register9GvBrErE6OQ_45Yu_45_Zi6Fobh50Em_Ar6XA8u8dCVqzb4Meta } from "/codebuild/output/src2681438712/src/src/pages/contact-form/register.vue?macro=true";
import { default as complete6sz8KN3JLywGrPLbu8UpEm9xu7hXihFxDS1VNfsuqF0Meta } from "/codebuild/output/src2681438712/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexjnlr5vApOHfRtGqYfFKNEeMtnx4ITsdbLANMBOn4aqYMeta } from "/codebuild/output/src2681438712/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmBCkdAj5sFyT1Vml9dyir6KzkmA7Yd3zdMER7oG5MvW4Meta } from "/codebuild/output/src2681438712/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completefsB6Sgpf0v_451U_453rsbMaffhSADRZoDDFRg5mZrQyyxkMeta } from "/codebuild/output/src2681438712/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexaYcr9wUhNpe0N9_wc7kd_45wOy_45NszgO_454Py1AVhjPx_45EMeta } from "/codebuild/output/src2681438712/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93cXzzvNl4ZXVlxXL2Ve_45px_7jQJ2kiBkZhlj0yu8fCtoMeta } from "/codebuild/output/src2681438712/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeK80KxllJOF6lnB0KmpvURSFUCeJofKCS2mkT3qrWM_45kMeta } from "/codebuild/output/src2681438712/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45alias2UvEvX83GeSOBtYKaKdccsePEK3bYESZDQC6L4ICqbcMeta } from "/codebuild/output/src2681438712/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplehf8T1tpksSPwaisc4PbZSLITuOjcpVxrx879m0_nnSYMeta } from "/codebuild/output/src2681438712/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45email8XKavyuXTEXzCdqeD2My3YsSrQofnXUfuQSqrTJUEXUMeta } from "/codebuild/output/src2681438712/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmgiQYU9OUioCK9RCorUnESdLrfv5zHpk9g7URYMn7Z5YMeta } from "/codebuild/output/src2681438712/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentWEM_45qmzoMy6sk0tj7OoJRNyTJr_45Iv_45we_fEYcpzwyvgMeta } from "/codebuild/output/src2681438712/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirml_45CX4Y0d22KnYSHX0xuXpJdR78x_45pqQJakPpzg9FMo0Meta } from "/codebuild/output/src2681438712/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateRc4wqCmmZmVpXCgkzWV9zJoke10avw3x3gjm38PMHCUMeta } from "/codebuild/output/src2681438712/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeWqDaNfY0nHsxtiJdlFAKD36Vxbmj3ghFUaGRqV7DBWMMeta } from "/codebuild/output/src2681438712/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeFAMtQAJId98xKAPFEw_45G_45hoTpAbNINVvh_JvlI4r5X0Meta } from "/codebuild/output/src2681438712/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45password7JqpjP5PsJ4mTSUMLVuOJQcRmAZLU4H9fthQGLSykz0Meta } from "/codebuild/output/src2681438712/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasUgBfVFPAtBs0HgYBr7bBZUx98uf3QmUsd_45y837U9FI0Meta } from "/codebuild/output/src2681438712/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerSnGaYtS4TxHUt3syZi6_45c6_45tYDQ67uyyo8Nw_V8bPycMeta } from "/codebuild/output/src2681438712/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codes8k1eJEp44eX7w6OiUg3CcnC_ymq72XcVKchSKRtMSEMeta } from "/codebuild/output/src2681438712/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexAvAkWfHO3ChjYtJKC5XPqZ9lM_452cEwKF0gSNZ0VQaDMMeta } from "/codebuild/output/src2681438712/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexOHPRgGlKB9e8dbpXZ6txbBO0yM4yzPL_HNjMY_Yc42EMeta } from "/codebuild/output/src2681438712/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as index4V4BodextAYljLF5FPvy1_45LoxQRKslYbk66iBXpA8ioMeta } from "/codebuild/output/src2681438712/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexxk2LDv7dcVxDbeC3p7OT3WHwHpo3smffQRtlNmJkiLMMeta } from "/codebuild/output/src2681438712/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatebgk1a9T520UDyZaB9nJqQxjopXdlj61be7an43dKAcwMeta } from "/codebuild/output/src2681438712/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeuqYeljOut5LCBMNl_trS3T0ZTWDhHodFVFvPFO3KfEUMeta } from "/codebuild/output/src2681438712/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirm_45rqembGvAOpCppHhP1SYr7_45dY4o_OVpQ9TJ6LPDVqrgMeta } from "/codebuild/output/src2681438712/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexpJlgIRf113qu4Sh5niMpSnynGdVQeAlNQZZp5UJf6B4Meta } from "/codebuild/output/src2681438712/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completejNalLYs8cbKDB0AMO3rNy9IPMHNlqbQhI_45_45G2_eYcekMeta } from "/codebuild/output/src2681438712/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateoJA5WwTKN_45_fiWjOI_45g92hsU7a4kSalJKAIp3w8kbycMeta } from "/codebuild/output/src2681438712/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexroA5oIsNNx6mrxVaeXNjrFxxIF1KH1eoFr_JW1wbhDMMeta } from "/codebuild/output/src2681438712/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexnll7ZhkacbrwvvjySWJNXCuIiplSyXg7vIwLAgsUItYMeta } from "/codebuild/output/src2681438712/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeux156RLd23B6CgeeJEkcKdBP2ndEwkE_YCLmJxBT9TsMeta } from "/codebuild/output/src2681438712/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexcnSYq2Ka6dvYNK_6cel3k_45GElKoZTRPhgKfKgPfjiSsMeta } from "/codebuild/output/src2681438712/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeE3OFrM1uReH_SuOJ_5DsbjvKVcLbRhfvbp9su_xB05cMeta } from "/codebuild/output/src2681438712/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexAL8WEuwT7KCKcwTxCKWAjHT_45YhGQUJ_45YTEO_45etvqEeAMeta } from "/codebuild/output/src2681438712/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexBwRTp_LLGYDKXN_f49K8qgDqkeyd0voHnczQSIAiWPIMeta } from "/codebuild/output/src2681438712/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexrLmv_6OJnIQpM8GlhPwr_45YIcF7N0iOvkmsVCCo1eJTMMeta } from "/codebuild/output/src2681438712/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as update_45ERFedjnciEAk6he4jimC6179GmopKGGKt7itqQsp_45MMeta } from "/codebuild/output/src2681438712/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmIAaoRcs_45mMsCg6XgOT7BetJ1d1Uqg_45Ga1HFTDZzlw1gMeta } from "/codebuild/output/src2681438712/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuFW_45BKAPgy9ExHRoWrsfKaUwtOo_3L7M_45yDEHBmwx28EMeta || {},
    component: () => import("/codebuild/output/src2681438712/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexVpUGoF8zpokfJjg3aUEq_PP8sAS0DdQ1iUBpzScPjhoMeta || {},
    component: () => import("/codebuild/output/src2681438712/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexJn4uWZaq5W3QNtKdNrOFNrqdAkr4xV844BM2lsPuYRkMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src2681438712/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src2681438712/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src2681438712/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src2681438712/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexm9K9UfKa4QbXDu49JcDkdLxf3ULxz0GGZAx11sMXYcYMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src2681438712/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexxU9xeynoDn78ZCCkRpSHWR8cJSa4aWCwlf6POgqIvLEMeta || {},
    component: () => import("/codebuild/output/src2681438712/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexDA7DYLiS4CEK0AjNZl8FfI_45Y_456lnjcBV2OvJn4tYZIAMeta || {},
    component: () => import("/codebuild/output/src2681438712/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2681438712/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2681438712/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexWLKdjoGcezofSuQjAltGyJzfxIrTlvSruOLGaCMIwwEMeta || {},
    component: () => import("/codebuild/output/src2681438712/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src2681438712/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmctxw9RKu1weOa_453Yvw6sZIldpCzsDQU5j4IQg_y_i8wMeta || {},
    component: () => import("/codebuild/output/src2681438712/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirm94g0usZr3JglO_45zhHlTO04w0dS_45nij8CDD4K_Rqzi_45IMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src2681438712/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completef72axcb1Mjir0CdUZTQTo8YH_45I0API2biiJ5cwJKji8Meta || {},
    component: () => import("/codebuild/output/src2681438712/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerTDUsPStpFePLBWwgaUKhGLCoozJE8vsAdHnvKoXIrbIMeta || {},
    component: () => import("/codebuild/output/src2681438712/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmqAx0TLigaYXzwLXzhYSgIuQf7OS8INrs6ScLYCVJJjsMeta || {},
    component: () => import("/codebuild/output/src2681438712/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeDpX5ERMCjxG3KQK1k7MZJjsOKxUoon_45QzzqcTvPS720Meta || {},
    component: () => import("/codebuild/output/src2681438712/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codepc7LlaUEewiDv0azfhu4vFgkUcCxRdBs86S_03zqJu0Meta || {},
    component: () => import("/codebuild/output/src2681438712/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeekkJr_SsLOMG4_45Bro1fRWccA8LPSqDDAZKnyCVCQYAoMeta || {},
    component: () => import("/codebuild/output/src2681438712/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: register9GvBrErE6OQ_45Yu_45_Zi6Fobh50Em_Ar6XA8u8dCVqzb4Meta || {},
    component: () => import("/codebuild/output/src2681438712/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmBCkdAj5sFyT1Vml9dyir6KzkmA7Yd3zdMER7oG5MvW4Meta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src2681438712/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completefsB6Sgpf0v_451U_453rsbMaffhSADRZoDDFRg5mZrQyyxkMeta || {},
    component: () => import("/codebuild/output/src2681438712/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexaYcr9wUhNpe0N9_wc7kd_45wOy_45NszgO_454Py1AVhjPx_45EMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2681438712/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeK80KxllJOF6lnB0KmpvURSFUCeJofKCS2mkT3qrWM_45kMeta || {},
    component: () => import("/codebuild/output/src2681438712/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2681438712/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplehf8T1tpksSPwaisc4PbZSLITuOjcpVxrx879m0_nnSYMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2681438712/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45email8XKavyuXTEXzCdqeD2My3YsSrQofnXUfuQSqrTJUEXUMeta || {},
    component: () => import("/codebuild/output/src2681438712/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmgiQYU9OUioCK9RCorUnESdLrfv5zHpk9g7URYMn7Z5YMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2681438712/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentWEM_45qmzoMy6sk0tj7OoJRNyTJr_45Iv_45we_fEYcpzwyvgMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2681438712/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirml_45CX4Y0d22KnYSHX0xuXpJdR78x_45pqQJakPpzg9FMo0Meta || {},
    component: () => import("/codebuild/output/src2681438712/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeWqDaNfY0nHsxtiJdlFAKD36Vxbmj3ghFUaGRqV7DBWMMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2681438712/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeFAMtQAJId98xKAPFEw_45G_45hoTpAbNINVvh_JvlI4r5X0Meta || {},
    component: () => import("/codebuild/output/src2681438712/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45password7JqpjP5PsJ4mTSUMLVuOJQcRmAZLU4H9fthQGLSykz0Meta || {},
    component: () => import("/codebuild/output/src2681438712/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2681438712/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerSnGaYtS4TxHUt3syZi6_45c6_45tYDQ67uyyo8Nw_V8bPycMeta || {},
    component: () => import("/codebuild/output/src2681438712/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codes8k1eJEp44eX7w6OiUg3CcnC_ymq72XcVKchSKRtMSEMeta || {},
    component: () => import("/codebuild/output/src2681438712/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src2681438712/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]